export default "__VITE_ASSET__BpRc2CEu__"